import Config from '../Config';
import Options from '../Options';

const type = "clock_in_out";

const Templates = (toolbar, callback) => {
    const configuations = Config[type] !== undefined ? Config[type] : [];

    return configuations.map((value, key) => {
        const name = value.name;
        const configuation = value.configuation;
        return {
            id: "fz-"+ type +"-tab-"+key,
            title: name,
            icon: toolbar.icons.grid,
            handler: function() {

                const oldConfigs = toolbar.pivot.getReport();

                toolbar.pivot.setOptions(Options);
                toolbar.pivot.removeAllConditions();
                toolbar.pivot.refresh();

                if(
                    oldConfigs.slice !== undefined && 
                    oldConfigs.slice.reportFilters !== undefined
                ) {
                    const filters = [...oldConfigs.slice.reportFilters];
                    const filtersLength = filters.length;
                    for(let i = 0; i < filtersLength; i++) {
                        const filter = filters[i];
                        if(filter.uniqueName == undefined) {
                            continue;
                        }
                        toolbar.pivot.clearFilter(filter.uniqueName);
                    }
                }

                if(configuation.slice !== undefined) {
                    toolbar.pivot.runQuery(configuation.slice);
                }
                if(configuation.options !== undefined) {
                    toolbar.pivot.setOptions(configuation.options);
                }
                if(configuation.formats !== undefined) {
                    const formats = [...configuation.formats];
                    const formatsLength = formats.length;
                    for(let i = 0; i < formatsLength; i++) {
                        toolbar.pivot.setFormat(formats[i]);
                    }
                }
                if(configuation.conditions !== undefined) {
                    const conditions = [...configuation.conditions];
                    const conditionsLength = conditions.length;
                    for(let i = 0; i < conditionsLength; i++) {
                        toolbar.pivot.addCondition(conditions[i]);
                        toolbar.pivot.refresh();
                    }
                }
                toolbar.pivot.refresh();
                callback(name, configuation)
            }
        }
    });
}

export default Templates;